import template from './racedaysAddPage.html';
import controller from './racedaysAddPage.controller';
import './racedaysAddPage.scss';

let racedaysAddPageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default racedaysAddPageComponent;
